import React, { useEffect, useState } from "react";
import { Box } from "@fuegokit/react";

import {
  StyledTag,
  StyledScrollArea,
  StyledScrollAreaViewport,
  StyledScrollAreaScrollbar,
  StyledScrollAreaThumb,
} from "../StoryStyles/ScrollAreaStyles";

const TAGS = Array.from({ length: 50 }).map(
  (_, i, a) => `@fuegokit/react v2.0.0-beta.${a.length - i}`
);

const StyledScrollAreaExample = () => {
  const [domLoaded, setDomLoaded] = useState(false);

  useEffect(() => {
    setDomLoaded(true);
  }, []);
  return (
    <Box sx={{ width: "768px" }}>
      {domLoaded && (
        <StyledScrollArea>
          <StyledScrollAreaViewport>
            <Box sx={{ px: 3, py: 5 }}>
              <Box className="Text">Tags</Box>
              {TAGS.map((tag) => (
                <StyledTag key={tag}>{tag}</StyledTag>
              ))}
            </Box>
          </StyledScrollAreaViewport>
          <StyledScrollAreaScrollbar orientation="vertical">
            <StyledScrollAreaThumb />
          </StyledScrollAreaScrollbar>
          <StyledScrollAreaScrollbar orientation="horizontal">
            <StyledScrollAreaThumb />
          </StyledScrollAreaScrollbar>
          <StyledScrollArea.Corner />
        </StyledScrollArea>
      )}
    </Box>
  );
};

export default StyledScrollAreaExample;
